// @flow
import type { Dispatch } from 'redux';
export const mapDispatchToProps = (dispatch: Dispatch<any>) => ({ dispatch });
